import React, { Suspense } from "react";
import {BrowserRouter} from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store,persistor  } from "./redux/store";
import PublicRoutes from "./routes/routes";
import { Spin } from "antd";
import AppLayout from "./components/appLayout";
const App = () => {
  
  // Suppress ResizeObserver warnings
const resizeObserverLoopErrRe = /^[^(ResizeObserver loop limit exceeded)]/;
const resizeObserverLoopErr = /^ResizeObserver loop completed with undelivered notifications/;

window.addEventListener('error', (e) => {
  if (resizeObserverLoopErrRe.test(e.message) || resizeObserverLoopErr.test(e.message)) {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.setAttribute('style', 'display: none');
    }
    if (resizeObserverErr) {
      resizeObserverErr.setAttribute('style', 'display: none');
    }
  }
});

// get token from pingID
  const valueTokenUrl = window.location.href;
  if (valueTokenUrl?.split('access_token=')[1] !== undefined) {
    localStorage.setItem('pingAccessToken', valueTokenUrl?.split('access_token=')[1]);
  }

  return (
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Suspense fallback={<div className="loader"><Spin /></div>}>
            <PublicRoutes/>
          </Suspense>
      </PersistGate>
    </Provider>
  );
};

export default App;
